import Model from "hooks/Model";
import * as React from "react";
import { useNavigate } from "react-router-dom";

const ThreadsAuth = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const codeParam = urlParams.get("code");
  const navigate = useNavigate();

  React.useEffect(() => {
    if (codeParam) {
      Model.setData("dialog", {
        open: true,
        title: "Vinculación éxitosa",
        text: "Tu perfil de Threads se ha vinculado correctamente, ya puedes continuar usando nuestros servicios normalmente.\n\nSiguiendo nuestra política de tratamiento de datos, si en esta ocasión deseas eliminar tus datos de nuestra plataforma, escríbenos a [[WhatsApp]] para cualquier solicitud.",
        link: "https://api.whatsapp.com/send?app_absent=0&phone=573012069045&text=Tengo%20una%20solicitud%20&type=phone_number",
        txtRight: "Entendido",
        fnRight: () => {
          navigate("/");
          Model.setData("dialog", {
            open: false,
          });
        },
        onClose: () => {
          navigate("/");
          Model.setData("dialog", {
            open: false,
          });
        },
      });
    } else {
      navigate("/");
    }
    //eslint-disable-next-line
  }, [codeParam]);

  return <div />;
};

export default ThreadsAuth;
